import * as tslib_1 from "tslib";
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CheckboxDialogComponent } from './checkbox/checkbox.dialogcomponent';
import { CountdownDialogComponent, BaseCountdownDialogOptions } from './countdown/countdown.dialogcomponent';
import { ConfirmationDialogComponent, BaseConfirmationDialogOptions } from './confirmation/confirmation.dialogcomponent';
import { InputBoxDialogComponent, BaseInputBoxDialogOptions } from './inputbox/inputbox.dialogcomponent';
import { LoginBoxDialogComponent, BaseLoginBoxDialogOptions, BaseLoginBoxDialogResult } from './loginbox/loginbox.dialogcomponent';
import { MessageBoxDialogComponent, BaseMessageBoxDialogOptions } from './messagebox/messagebox.dialogcomponent';
import { NotificationDialogComponent, BaseNotificationDialogOptions } from './notification/notification.dialogcomponent';
import { OutOfOfficeDesigneeSearchDialogComponent, BaseOOODesigneeSearchDialogOptions, BaseOOODesigneeSearchResult, } from './ooodesigneesearch/ooodesigneesearch.dialogcomponent';
import { OptionBoxDialogComponent, BaseOptionBoxDialogOptions, BaseOptionBoxOption } from './optionbox/optionbox.dialogcomponent';
import { ReportOptionsDialogComponent, BaseReportOptionsDialogOptions, BaseReportOptionsResult, } from './reportoptions/reportoptions.dialogcomponent';
import { SelectBoxDialogComponent, BaseSelectBoxDialogOptions, BaseSelectBoxSelectionOption, } from './selectbox/selectbox.dialogcomponent';
import { SelectBoxNoteDialogComponent, BaseSelectBoxNoteDialogOptions, BaseSelectBoxNoteSelectionOption, BaseSelectBoxNoteResult, } from './selectboxnote/selectboxnote.dialogcomponent';
import { SubordinateDialogComponent, BaseSubordinateDialogOptions, BaseSubordinateDialogResult, } from './subordinate/subordinate.dialogcomponent';
import { TextNoteDialogComponent, BaseTextNoteDialogOptions, BaseTextNoteDialogResult } from './textnote/textnote.dialogcomponent';
import { TimeApproveDialogComponent, } from './timeapprove/timeapprove.dialogcomponent';
import { TimeRequestDialogComponent, BaseTimeRequestDialogOptions, BaseTimeRequestResult, } from './timerequest/timerequest.dialogcomponent';
import { UserSearchDialogComponent, BaseUserSearchDialogOptions, BaseUserSearchResult, } from './usersearch/usersearch.dialogcomponent';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "@angular/flex-layout/core";
export { BaseCountdownDialogOptions as CountdownDialogOptions };
export { BaseConfirmationDialogOptions as ConfirmationDialogOptions };
export { BaseInputBoxDialogOptions as InputBoxDialogOptions };
export { BaseLoginBoxDialogOptions as LoginBoxDialogOptions };
export { BaseLoginBoxDialogResult as LoginBoxDialogResult };
export { BaseMessageBoxDialogOptions as MessageBoxDialogOptions };
export { BaseNotificationDialogOptions as NotificationDialogOptions };
export { BaseOptionBoxDialogOptions as OptionBoxDialogOptions };
export { BaseOptionBoxOption as OptionBoxOption };
export { BaseOOODesigneeSearchDialogOptions as OOODesigneeSearchDialogOptions };
export { BaseReportOptionsDialogOptions as ReportOptionsDialogOptions };
export { BaseReportOptionsResult as ReportOptionsResult };
export { BaseSelectBoxDialogOptions as SelectBoxDialogOptions };
export { BaseSelectBoxSelectionOption as SelectBoxSelectionOption };
export { BaseSelectBoxNoteDialogOptions as SelectBoxNoteDialogOptions };
export { BaseSelectBoxNoteResult as SelectBoxNoteResult };
export { BaseSelectBoxNoteSelectionOption as SelectBoxNoteSelectionOption };
export { BaseSubordinateDialogOptions as SubordinateDialogOptions };
export { BaseSubordinateDialogResult as SubordinateDialogResult };
export { BaseTextNoteDialogOptions as TextNoteDialogOptions };
export { BaseTextNoteDialogResult as TextNoteDialogResult };
export { BaseTimeRequestDialogOptions as TimeRequestDialogOptions };
export { BaseTimeRequestResult as TimeRequestResult };
export { BaseUserSearchDialogOptions as UserSearchDialogOptions };
var DialogService = /** @class */ (function () {
    function DialogService(matDialog, mediaChange) {
        var _this = this;
        this.matDialog = matDialog;
        this.mediaChange = mediaChange;
        this._subrelease = new Subject();
        this.smallMediaSize = mediaChange.isActive('screen and (max-width: 959px)');
        // Observe for media changes
        this.mediaChange.media$.pipe(takeUntil(this._subrelease)).subscribe(function (media) {
            // Set flags accordingly with what we know.
            _this.smallMediaSize = media.mqAlias === 'xs' || media.mqAlias === 'sm';
        });
    }
    // #region Close All Dialogs Service Call
    DialogService.prototype.CloseAllDialogs = function () {
        this.matDialog.closeAll();
    };
    // #endregion
    // #region Open Checkbox Dialog Service Call
    DialogService.prototype.OpenCheckboxDialog = function (options) {
        var openHandle = this.matDialog.open(CheckboxDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Information Requested', MessageText: '', OKText: 'OK' }, options),
            width: options.width || '800px',
            height: options.height || '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Confirmation Dialog Service Call
    DialogService.prototype.OpenConfirmationDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Confirmation Requested...', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            panelClass: 'confdialog',
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            // dlgoptions.width = '80vw';
            // dlgoptions.height = '80vh';
            dlgoptions.panelClass = ['confdialog', 'smalldialogpanel'];
        }
        var openHandle = this.matDialog.open(ConfirmationDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Countdown Dialog Service Call
    DialogService.prototype.OpenCountdownDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Please Wait...', MessageText: '', OKText: 'OK', CancelText: 'Cancel', Time: 60 }, options),
            width: '500px',
            height: '18rem',
            maxHeight: '85vh',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            // dlgoptions.height = '80vh';
            dlgoptions.height = '30rem';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(CountdownDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open OOO Designee Search Dialog Service Call
    DialogService.prototype.OpenOOODesigneeSearchDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'User Search', MessageText: '', OKText: 'Select', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '800px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.height = '80vh';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(OutOfOfficeDesigneeSearchDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Input Box Dialog Service Call
    DialogService.prototype.OpenInputBoxDialog = function (options) {
        var openHandle = this.matDialog.open(InputBoxDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Information Requested...', MessageText: '', InputHint: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Login Box Dialog Service Call
    DialogService.prototype.OpenLoginBoxDialog = function (options) {
        var openHandle = this.matDialog.open(LoginBoxDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Credentials Required...', MessageText: '', InputHint: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Message Box Dialog Service Call
    DialogService.prototype.OpenMessageBoxDialog = function (options) {
        var self = this;
        var openHandle = self.matDialog.open(MessageBoxDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Information', MessageText: '', OKText: 'OK' }, options),
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Notification Dialog Service Call
    DialogService.prototype.OpenNotificationDialog = function (options) {
        var self = this;
        var openHandle = self.matDialog.open(NotificationDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Notification Details', MessageText: '', OKText: 'OK' }, options),
            width: self.smallMediaSize ? '80vw' : options.width || '900px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Option Box Dialog Service Call
    DialogService.prototype.OpenOptionBoxDialog = function (options) {
        var openHandle = this.matDialog.open(OptionBoxDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Please select', MessageText: '', Options: [] }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Report Options Dialog Service Call
    DialogService.prototype.OpenReportOptionsDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Choose Report Options...', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
        };
        if (options.width) {
            dlgoptions.width = options.width;
        }
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            // dlgoptions.height = '80vh';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(ReportOptionsDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Select Box Dialog Service Call
    DialogService.prototype.OpenSelectBoxDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Make Choice...', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.height = '80vh';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(SelectBoxDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Select Box Note Dialog Service Call
    DialogService.prototype.OpenSelectBoxNoteDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Make Choice...', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.height = '80vh';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(SelectBoxNoteDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Subordinate Dialog Service Call
    DialogService.prototype.OpenSubordinateDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Make Choice...', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.height = '80vh';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(SubordinateDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Text Note Dialog Service Call
    DialogService.prototype.OpenTextNoteDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Optional Note', MessageText: '', OKText: 'OK' }, options),
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.height = '80vh';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(TextNoteDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Time Approve Dialog Service Call
    DialogService.prototype.OpenTimeApproveDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Mark Board Time Approval', MessageText: '', OKText: 'OK' }, options),
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(TimeApproveDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Time Request Dialog Service Call
    DialogService.prototype.OpenTimeRequestDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(TimeRequestDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Request Time Approval', MessageText: '', OKText: 'OK' }, options),
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open User Search Dialog Service Call
    DialogService.prototype.OpenUserSearchDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'User Search', MessageText: '', OKText: 'Select', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
            width: self.smallMediaSize ? '80vw' : options.width || '800px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.height = '80vh';
            dlgoptions.panelClass = 'smalldialogpanel';
        }
        var openHandle = this.matDialog.open(UserSearchDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    DialogService.ngInjectableDef = i0.defineInjectable({ factory: function DialogService_Factory() { return new DialogService(i0.inject(i1.MatDialog), i0.inject(i2.MediaObserver)); }, token: DialogService, providedIn: "root" });
    return DialogService;
}());
export { DialogService };
// #region Custom Classes
// #region Base Dialog Options Class
var BaseDialogOptions = /** @class */ (function () {
    function BaseDialogOptions() {
    }
    return BaseDialogOptions;
}());
export { BaseDialogOptions };
